import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import "./userDetails.styl";
import {UserDetail} from "../../../models/user";
import {LanguageManager} from "../../../languages/languages";
import {ConfigService} from "../../../helpers/services/configService";
import {RouterManager, Routes} from "../../../router";
import {eventBus, signalNames} from "../../../bus";
import {application} from "../../../stores/application";
const template = require("./userDetails.vue");

@Component({
  template: template
})
export class UserDetailsComponent extends Vue {

  user: UserDetail = null;
  loading: boolean = false;
  response: any = null;
  dialog: boolean = false;

  headers = [
    { text: LanguageManager.instance.i18n.t("automationName"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("automationUuid"), align: "left", sortable: false }
  ];

  created(): void {
    this.refreshUser();
    this.dialog = false;
  }

  refreshUser() {
    this.user = null;
    application.commitStartLoader(this.$store);
    Vue.http.get(ConfigService.users + "/" + this.$route.params.id, {})
      .then(response => {
        this.user = new UserDetail().deserialize(response.data.data);
        eventBus.$emit(signalNames.setToolbarOptions, {
          title: this.user.name + " " + this.user.surname  + " - Total automations: " + this.user.total_automations + " ",
          backAction: () => RouterManager.instance.router.push(Routes.users),
          reloadAction: () => this.refreshUser()
        });
        console.log("automazioni: ", this.user.automations);
        application.commitStopLoader(this.$store);
      })
      .catch(error => {
        application.commitStopLoader(this.$store);
        eventBus.$emit(signalNames.showError);
      });
  }

  handleClickAutomation(automationId) {
    this.$router.push({name: Routes.automationDetail.name,  params: { id: automationId }});
  }

  handleDeleteClick() {
    this.loading = true;
    Vue.http.delete(ConfigService.users + "/" + this.user.id + "", {})
      .then(response => {
        console.log("user delete", response);
        this.dialog = false;
        this.response = response.body;
        this.loading = false;
        this.$router.push({name: Routes.users.name});
        // Vue.http.delete(ConfigService.apiEndpoint1 + ConfigService.automations1 + "/" + this.automation.uuid + "", {})
        //   .then(response => {
        //     console.log("automation delete", response);
        //     this.response = response.body;
        //     this.loading = false;
        //     RouterManager.instance.router.push(Routes.automations);
        //   })
        //   .catch(error => {
        //     this.loading = false;
        //     eventBus.$emit(signalNames.showError);
        //     RouterManager.instance.router.push(Routes.automations);
        //     throw error;
        //   });
      })
      .catch(error => {
        this.loading = false;
        eventBus.$emit(signalNames.showError, "L'utente non è stato eliminato correttamente. Riprovare o contattare l'amministratore");
      });
  }

}

Vue.component("cmUserDetails", UserDetailsComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/userDetails/userDetails.ts